/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Instance } from '../../../../ts/instance';

export function mapInstance(attributes) {
  const instance: Instance = {
    instance_id: attributes.id,
    crn: attributes.id,
    name: attributes.entity.name,
    region: attributes.region,
    plan: attributes.plan
  };

  if (attributes.entity.account_id) {
    instance.account = {
      id: attributes.entity.account_id,
      name: attributes.entity.account_name
    };
  }
  if (attributes.entity.resource_group_id) {
    instance.resourceGroup = {
      id: attributes.entity.resource_group_id,
      name: attributes.entity.resource_group_name
    };
  }

  return instance;
}
